<template>
  <div class="update-password-page-wrapper">
    <div class="update-password-container">
      <div class="main-content">
        <!-- 找回密码区域容器 -->
        <div class="password-wrapper">
          <!-- 找回密码表单 -->
          <div class="p-form-container">
            <el-card class="p-card" shadow="always">

              <!-- 表单内容 -->
              <div class="p-body">
                <div class="p-form-wrapper">
                  <!-- 顶部标题 -->
                  <div class="password-header">
                    <h3>找回密码</h3>
                  </div>

                  <!-- 忘记密码表单 -->
                  <el-form
                        ref="forgotFormRef"
                        :model="forgotForm"
                        :rules="forgotRules"
                        class="password-form"
                    >
                      <el-form-item prop="phone">
                        <el-input
                            v-model="forgotForm.phone"
                            placeholder="请输入手机号"
                            size="large"
                            class="form-input"
                        >
                          <template #prefix>
                            <el-icon>
                              <User/>
                            </el-icon>
                          </template>
                        </el-input>
                      </el-form-item>

                      <el-form-item prop="verifyCode">
                        <el-input
                            v-model="forgotForm.verifyCode"
                            placeholder="请输入验证码"
                            size="large"
                            class="form-input"
                        >
                          <template #prefix>
                            <el-icon> <Message /></el-icon>
                          </template>
                          <template #suffix>
                            <el-button
                                link
                                class="captcha-btn"
                                :disabled="countdown > 0"
                                @click="sendVerifyCode"
                            >
                              {{ countdown > 0 ? `${countdown}秒后重试` : '获取验证码' }}
                            </el-button>
                          </template>
                        </el-input>

                      </el-form-item>

                      <el-form-item prop="newPassword">
                        <el-input
                            v-model="forgotForm.newPassword"
                            type="password"
                            placeholder="请输入新密码（至少8位）"
                            size="large"
                            class="form-input"
                            show-password
                        >
                          <template #prefix>
                            <el-icon>
                              <Lock/>
                            </el-icon>
                          </template>
                        </el-input>
                      </el-form-item>

                      <el-form-item prop="confirmPassword">
                        <el-input
                            v-model="forgotForm.confirmPassword"
                            type="password"
                            placeholder="请确认新密码"
                            size="large"
                            class="form-input"
                            show-password
                        >
                          <template #prefix>
                            <el-icon>
                              <Lock/>
                            </el-icon>
                          </template>
                        </el-input>
                      </el-form-item>

                      <el-form-item>
                        <el-button
                            type="primary"
                            @click="handleForgotPassword"
                            class="submit-btn"
                            size="large"
                        >
                          重置密码
                        </el-button>
                      </el-form-item>
                    </el-form>


                  <!-- 底部链接 -->
                  <div class="footer-links">
                    <el-link type="primary" @click="backToLogin" class="back-link" :underline="false">
                      < 登录
                    </el-link>
                  </div>
                </div>
              </div>
            </el-card>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部版权信息 -->
    <el-footer class="footer" height="auto">
      <div class="footer-content">
        <div class="footer-main">
          <div class="footer-sections">
            <!-- 网站介绍 -->
            <div class="footer-section">
              <div class="footer-logo">

              </div>
              <p class="footer-desc">
                专业的印前设计工具，让设计更加高效精准。我们致力于为各行业提供最优质的印前解决方案。
              </p>
            </div>

            <!-- 联系方式 -->
            <div class="footer-section">
              <h4 class="section-title">联系方式</h4>
              <div class="contact-info">
                <div class="contact-item">
                  <el-icon><Message /></el-icon>
                  <span>3052594895@qq.com</span>
                </div>
                <div class="contact-item">
                  <el-icon><Phone /></el-icon>
                  <span>18925330037</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 底部版权信息 -->
          <div class="footer-bottom">
            <div class="copyright-section">
              <div class="copyright-text">
                © 2025 中山市易印网络科技有限公司.保留所有权利.
              </div>

            </div>
            <div class="certification-info">
              <div class="beian-container">
                <img src="https://test.eprinttools.com/files/front-end/police.png" alt="公安备案图标" class="beian-icon">
                <a href="http://www.beian.gov.cn" target="_blank" class="beian-link">
                  粤公网安备 44200002443702号
                </a>
                <span class="divider">|</span>
                <a href="https://beian.miit.gov.cn/" target="_blank" class="icp-link">
                  粤ICP备16014837号
                </a>
              </div>
              <div class="legal-links">
                <a href="/privacyPolicy" @click.prevent="showPrivacyDialog" class="legal-link">隐私政策</a>
                <span class="divider">|</span>
                <a href="/userAgreement" @click.prevent="showTermsDialog" class="legal-link">用户协议</a>
                <span class="divider">|</span>
                <a class="legal-link">法律声明</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-footer>
  </div>
</template>

<script>
import { ref, reactive, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import request from '@/utils/request'

export default {
  name: "UpdatePassword",

  setup() {
    const router = useRouter()

    // 响应式数据
    const countdown = ref(0)
    const timer = ref(null)

    // 忘记密码表单
    const forgotForm = reactive({
      phone: '',
      verifyCode: '',
      newPassword: '',
      confirmPassword: ''
    })

    // 表单引用
    const forgotFormRef = ref()

    // 表单规则
    const forgotRules = {
      phone: [
        {required: true, message: '请输入手机号', trigger: 'blur'},
        {pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur'}
      ],
      verifyCode: [
        {required: true, message: '请输入验证码', trigger: 'blur'}
      ],
      newPassword: [
        {required: true, message: '请输入新密码', trigger: 'blur'},
        {min: 8, message: '密码长度至少8位', trigger: 'blur'}
      ],
      confirmPassword: [
        {required: true, message: '请确认新密码', trigger: 'blur'},
        {
          validator: (rule, value, callback) => {
            if (value !== forgotForm.newPassword) {
              callback(new Error('两次输入的密码不一致'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }
      ]
    }

    // 发送验证码
    const sendVerifyCode = async () => {
      if (!forgotForm.phone) {
        ElMessage.error('请输入手机号')
        return
      }

      if (!/^1[3-9]\d{9}$/.test(forgotForm.phone)) {
        ElMessage.error('请输入正确的手机号')
        return
      }

      try {
        await request.get('/auth/verify-code/phone', {
          params: {
            phone: forgotForm.phone,
            scene: 'Bind'
          }
        })

        ElMessage.success('验证码发送成功')
        startCountdown()
      } catch (error) {
        ElMessage.error(error.response?.data?.message || '验证码发送失败')
      }
    }

    // 开始倒计时
    const startCountdown = () => {
      countdown.value = 60
      timer.value = setInterval(() => {
        countdown.value--
        if (countdown.value <= 0) {
          clearInterval(timer.value)
        }
      }, 1000)
    }

    // 忘记密码提交
    const handleForgotPassword = async () => {
      if (!forgotFormRef.value) return

      try {
        await forgotFormRef.value.validate()

        const {confirmPassword, ...submitData} = forgotForm
        await request.post('/auth/forgot-password', submitData)

        ElMessage.success('密码重置成功')
        router.push('/login')
      } catch (error) {
        if (error.errors) {
          // 表单验证错误
          return
        }
        ElMessage.error(error.response?.data?.message || '密码重置失败')
      }
    }

    // 返回登录
    const backToLogin = () => {
      router.push('/login')
    }

    // 清理定时器
    const clearTimer = () => {
      if (timer.value) {
        clearInterval(timer.value)
      }
    }

    return {
      countdown,
      forgotForm,
      forgotFormRef,
      forgotRules,
      sendVerifyCode,
      handleForgotPassword,
      backToLogin,
      clearTimer
    }
  }
}
</script>


<style scoped lang="scss">
.update-password-page-wrapper {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: fixed;
}

.update-password-container {
  width: 100%;
  height: 65vh;
  background: url('https://test.eprinttools.com/files/front-end/login/lr-bg.png');
  background-size: cover;
  position: relative;
  overflow: hidden;
}

.main-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 0;
}

.password-wrapper {
  display: flex;
  width: 380px;
  height: 500px;
  max-width: 90%;
  max-height: 90vh;
  background: white;
  overflow: hidden;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
}

.p-form-container {
  width: 100%;
  position: relative;
  z-index: 2;
  max-width: 700px;
  padding: 0;

  .p-card {
    width: 100%;
    overflow: hidden;
    box-shadow: none;
    position: relative;
    padding: 0;
    border: none;

    :deep(.el-card__body) {
      padding: 0 !important;
    }
  }
}

/* 表单布局 */
.p-body {
  margin-top: 0 !important;
  padding: 0 !important;
  display: flex;
  max-height: 500px;
}


/* 表单区域 */
.p-form-wrapper {
  flex: 1;
  padding: 10px 40px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-height: 500px;
}

/* 头部 */
.password-header {
  margin-bottom: 25px;
  text-align: center;

  h3 {
    font-size: 24px;
    color: #2c3e50;
    margin-bottom: 8px;
    font-weight: 600;
  }
}

.password-form {
  min-height: 220px; /* 设置最小高度 */
  margin: 0 !important;
  flex-direction: column;
  justify-content: flex-start; /* 改为顶部对齐 */
}

/* 输入框样式 */
.form-input {
  :deep(.el-input__wrapper) {
    border-radius: 0;
    padding: 1px 12px;
    box-shadow: 0 0 0 1px #dcdfe6 inset;
    height: 38px;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 0 0 1px #c0c4cc inset;
    }

    &.is-focus {
      box-shadow: 0 0 0 1px #409EFF inset;
    }
  }

  :deep(.el-input__prefix) {
    left: 8px;
    color: #606266;
  }

  :deep(.el-input__suffix) {
    display: flex;
    align-items: center;
    padding-right: 8px;
  }

  :deep(.el-input__inner) {
    padding-right:90px;
  }

  .captcha-btn {
    padding: 0;
    height: auto;
    color: #373737;
    font-size: 13px;
    white-space: nowrap;
    margin-left: 4px;

    &:hover {
      color: #66b1ff;
    }

    &:disabled {
      color: #c0c4cc;
      cursor: not-allowed;
    }
  }

  :deep(input) {
    font-size: 14px;
    height: 16px;
    line-height: 36px;

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      -webkit-text-fill-color: #606266 !important;
      -webkit-box-shadow: 0 0 0px 1000px white inset !important;
      transition: background-color 5000s ease-in-out 0s;
    }
  }
}

.submit-btn {
  width: 100%;
  margin-top: 8px;
  border-radius: 0;
  padding: 10px 16px;
  font-weight: 600;
  letter-spacing: 6px;
  font-size: 14px;
  transition: all 0.3s;
  box-shadow: 0 3px 8px rgba(64, 158, 255, 0.3);
  height: 42px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 10px rgba(64, 158, 255, 0.4);
  }
}

.footer-links {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #e4e7ed;
}

.back-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;

  &:hover {
    text-decoration: none !important;
  }
}

.footer {
  color: #333;
  padding: 0;
  margin-top: auto;
  flex: 1;
  position: relative;

  .footer-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .footer-sections {
    display: grid;
    grid-template-columns: 2fr 2fr;
    gap: 40px;
    margin-bottom: 30px;
    padding: 10px;
    border-bottom: 1px solid rgb(1, 3, 11);
  }

  .footer-section:first-child {
    padding-right: 20px;
  }

  .footer-logo {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .footer-logo .logo-img {
    height: 40px;
    width: auto;
    margin-right: 12px;
  }

  .logo-text {
    font-size: 1.5rem;
    font-weight: 700;
    color: #01030b;
    background: linear-gradient(45deg, #ff7e5f, #feb47b);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .footer-desc {
    color: rgb(1, 3, 11);
    line-height: 1.6;
    font-size: 0.95rem;
    margin: 0;
  }

  .section-title {
    color: #01030b;
    font-size: 1.1rem;
    font-weight: 600;
    margin-bottom: 20px;
    position: relative;
  }

  .section-title::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 0;
    width: 30px;
    height: 2px;
    background: linear-gradient(45deg, #ff7e5f, #feb47b);
    border-radius: 1px;
  }

  .footer-links {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .footer-links li {
    margin-bottom: 12px;
  }

  .footer-links a {
    color: rgb(1, 3, 11);
    text-decoration: none;
    font-size: 0.9rem;
    transition: all 0.3s ease;
    display: inline-block;
  }

  .footer-links a:hover {
    color: #ff7e5f;
    transform: translateX(5px);
  }

  .contact-info {
    display: flex;
    flex-direction: row;
    gap: 20px;
    flex-wrap: wrap;
  }

  .contact-item {
    display: flex;
    align-items: center;
    gap: 10px;
    color: rgb(1, 3, 11);
    font-size: 0.9rem;
  }

  .contact-item .el-icon {
    color: #ff7e5f;
    font-size: 1.1rem;
  }

  /* 底部版权区域 */
  .footer-bottom {
    margin-top: -10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .copyright-section {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 200px;
  }

  .copyright-text {
    color: rgb(1, 3, 11);
    font-size: 0.9rem;
  }

  .legal-links {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .legal-link {
    color: rgb(1, 3, 11);
    text-decoration: none;
    font-size: 0.85rem;
    transition: color 0.3s ease;
  }

  .legal-link:hover {
    color: #ff7e5f;
    cursor: pointer !important;
  }

  .divider {
    color: rgb(1, 3, 11);
    font-size: 0.8rem;
  }

  .certification-info {
    display: flex;
    justify-content: center;
    gap: 20px;
  }

  .beian-container {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    justify-content: center;
  }

  .beian-icon {
    height: 16px;
    width: auto;
  }

  .beian-link, .icp-link {
    color: rgb(1, 3, 11);
    text-decoration: none;
    font-size: 0.8rem;
    transition: color 0.3s ease;
  }

  .beian-link:hover, .icp-link:hover {
    color: #ff7e5f;
  }
}

@media (max-width: 1600px) and (min-width: 762px) {
  .password-wrapper {
    width:290px;
    height: 380px;
  }

  .p-form-wrapper {
    padding: 15px; // 减少内边距
  }

  .password-header {
    margin-bottom: 15px;

    h3 {
      font-size: 18px; // 减小标题字体
      margin-bottom: 5px;
    }
  }

  .password-form {
    min-height: 150px;
    margin: 0 !important;
    flex-direction: column;
    justify-content: center;
  }


  .form-input {
    :deep(.el-input__wrapper) {
      height: 28px; // 减小输入框高度
      padding: 1px 8px;
    }

    :deep(.el-input__inner) {
      font-size: 11px; // 减小输入文字
      padding-right: 70px; // 调整按钮空间
    }

    .captcha-btn {
      font-size: 11px; // 验证码按钮文字缩小
    }
  }

  // 调整注册按钮
  .submit-btn {
    height: 32px;
    padding: 8px 12px;
    font-size: 13px;
    letter-spacing: 4px;
    margin-top: 5px;
  }

  // 调整登录链接
  .footer-links {
    text-align: center;
    padding-top: 15px;
    border-top: 1px solid #e4e7ed;
  }

  .back-link {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
  }

  /* 调整表单错误信息字体大小 */
  :deep(.el-form-item__error) {
    font-size: 10px !important;
    padding-top: 2px;
    line-height: 1.2;
  }

}

</style>
